import * as React from 'react';

interface IMTAChangeDetailsProps {
  text: string,
  icon: string,
  handleClick: any
  enabled?: boolean,
  largerIcon?: boolean,
}

export const MTAChangeDetails = ({
                                   text,
                                   icon,
                                   handleClick,
                                   enabled = true,
                                   largerIcon = false
                                 }: IMTAChangeDetailsProps) => {

  if (!enabled) {
    return null;
  }

  return (
    <div className={'m-a-change-selection-item-container'}>
      <div className={'m-a-change-selection-item'} onClick={handleClick}>
        <div className={'m-a-change-selection-image-container'}>
          <img className={largerIcon ? 'm-a-change-icon larger' : 'm-a-change-icon'}
               src={require(`../../../../../../scenes/MakeAChange/Images/${icon}`)} alt={''}/>
        </div>
        <div className={'m-a-change-selection-text-container'}>
          <div className={'m-a-change-selection-text'}>{text}</div>
        </div>
      </div>
    </div>
  )
}
